/* src/components/BatchSummaryScreen.js */
import React, { useMemo } from 'react';
import './BatchSummaryScreen.css'; // We will define css below

const BatchSummaryScreen = ({ 
    completedRules, 
    allItemsMap, 
    dailyProgress, 
    dailyTarget, 
    onContinue, 
    onFinish 
}) => {
    
    // Calculate progress percentage
    const progressPercent = Math.min(100, (dailyProgress / dailyTarget) * 100);
    const isDailyGoalMet = dailyProgress >= dailyTarget;

    return (
        <div className="batch-summary-container theme-aware">
            <div className="batch-header">
                <img src="mascot/logoKeepGoing.png" alt="Wali Mascot" className="keep-going-mascot" />
                <h2>Batch Complete!</h2>
                <p>Take a moment to consolidate these rules before moving on.</p>

                <div className="progress-section">
                    <div className="progress-labels">
                        <span>Today's Goal</span>
                        <span>{dailyProgress} / {dailyTarget} Rules</span>
                    </div>
                    <div className="progress-track">
                        <div className="progress-fill" style={{ width: `${progressPercent}%` }}></div>
                    </div>
                </div>
            </div>

            <div className="keynote-review-list">
                {completedRules.map(ruleId => {
                    const rule = allItemsMap.get(ruleId);
                    if (!rule) return null;
                    return (
                        <div key={ruleId} className="keynote-review-card">
                            <div className="review-rule-name">{rule.ruleName}</div>
                            <div className="review-keynote">
                                <span className="material-symbols-outlined icon">lightbulb</span>
                                <span>{rule.keynote || "No keynote written."}</span>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="batch-actions">
                <button className="btn secondary" onClick={onFinish}>
                    {isDailyGoalMet ? "Finish & Go Home" : "Take a Break"}
                </button>
                <button className="btn primary" onClick={onContinue}>
                    {isDailyGoalMet ? "Do Extra Credit" : "Next Batch (5)"}
                </button>
            </div>
        </div>
    );
};

export default BatchSummaryScreen;